module.exports = __webpack_public_path__ + "static/media/btn_secondaryschool_03_quiz.20df62d8.png";